import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import { IDelivery } from '@/core/models/IDelivery';
import { authService } from '../services/authService';
import { ApiResponse } from '@/core/models/ApiResponse';
import ExportHelper from '@/core/ExportHelper';
import moment from 'moment';

class BackendService {

    // Henter access token og legger til i axios
    private async getRequestConfig(): Promise<void> {
        return await authService.getAccessToken()
        .then(token => {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
        },
        err => {});
    }

    async getDeliveries(fromDate: Date, toDate: Date): Promise<AxiosResponse<ApiResponse<IDelivery[]>>> {
        await this.getRequestConfig();
        const vendorId = await authService.getVendorId();
        const toDateIso = toDate.toISOString();
        const fromDateIso = fromDate.toISOString();
        return axios
            .get<ApiResponse<IDelivery[]>>('/api/delivery/from/'+ fromDateIso + '/to/' + toDateIso + '/vendorId/' + vendorId);
    }

    async getDeliveriesWithReportData(fromDate: Date, toDate: Date): Promise<AxiosResponse<ApiResponse<IDelivery[]>>> {
        await this.getRequestConfig();
        const vendorId = await authService.getVendorId();
        const toDateIso = toDate.toISOString();
        const fromDateIso = fromDate.toISOString();
        return axios
            .get<ApiResponse<IDelivery[]>>('/api/delivery/withReportData/from/'+ fromDateIso + '/to/' + toDateIso + '/vendorId/' + vendorId);
    }

    async getVoucher(voucherNumber: string): Promise<AxiosResponse<IDelivery[]>> {
        await this.getRequestConfig();
        return axios
            .get<IDelivery[]>('/api/delivery/vouchernumber/' + voucherNumber);
    } 
    // https://stackoverflow.com/questions/41938718/how-to-download-files-using-axios
    // https://medium.com/@chomal/export-and-download-excel-files-with-net-core-and-react-dc7b5c40ecae
    async getExcelFile(fromDate: Date, toDate: Date, typeGet: string ): Promise<void> {
        await this.getRequestConfig();
        const vendorId = await authService.getVendorId();

        const toDateIso = toDate.toISOString();
        const fromDateIso = fromDate.toISOString();

        axios.request(
            {
                method: 'GET',
                url: 'api/export/' + vendorId +'/' + typeGet +'/from/' + fromDateIso + '/to/' + toDateIso,
                responseType: 'blob'
            }
        ).then(response => {
            let filename = 'leveranser-'+ typeGet + moment(toDateIso).format('DD-MM-YYYY') + '.xlsx';
            ExportHelper.saveFile(filename, response.data);
        });
    }

}

export const backendService = new BackendService(); 